import { zergApi } from "@/service/zerg";

class ReportsService {

    async getMonthlyAttendanceReport(params) {
        try {
            const data = await zergApi.post("monitoring/reports/get-monthly-attendance-report", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDetailedAttendanceReport(params) {
        try {
            const data = await zergApi.post("monitoring/reports/get-detailed-attendance-report", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getYearAttendanceReport(params) {
        try {
            const data = await zergApi.post("monitoring/reports/get-year-attendance-report", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcel(params) {
        try {
            const data = await zergApi.post("monitoring/reports/monthly-report-export-to-excel", params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new ReportsService();